import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { X } from "lucide-react";

function TagInput({ value = [], onChange, placeholder = "Digita e premi Enter..." }) {
	const [input, setInput] = useState("");

	const handleKeyDown = useCallback((e) => {
		if (e.key === "Enter" || e.key === ",") {
			e.preventDefault();
			const tag = input.trim();
			if (tag && !value.includes(tag)) {
				onChange([...value, tag]);
			}
			setInput("");
		}
		if (e.key === "Backspace" && !input && value.length > 0) {
			onChange(value.slice(0, -1));
		}
	}, [input, value, onChange]);

	const removeTag = useCallback((tag) => {
		onChange(value.filter((t) => t !== tag));
	}, [value, onChange]);

	return (
		<div className="flex flex-wrap items-center gap-1.5 rounded-md border border-slate-300 bg-white px-3 py-2 shadow-sm focus-within:ring-2 focus-within:ring-blue-500">
			{value.map((tag) => (
				<span
					key={tag}
					className="inline-flex items-center gap-1 rounded-md bg-blue-100 px-2 py-0.5 text-sm font-medium text-blue-800"
				>
					{tag}
					<button
						type="button"
						onClick={() => removeTag(tag)}
						className="inline-flex h-4 w-4 items-center justify-center rounded hover:bg-blue-200"
					>
						<X className="h-3 w-3" />
					</button>
				</span>
			))}
			<input
				type="text"
				value={input}
				onChange={(e) => setInput(e.target.value)}
				onKeyDown={handleKeyDown}
				placeholder={value.length === 0 ? placeholder : ""}
				className="min-w-[120px] flex-1 border-0 bg-transparent text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none"
			/>
		</div>
	);
}

TagInput.propTypes = {
	value: PropTypes.arrayOf(PropTypes.string),
	onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
};

export default TagInput;
